export default "__VITE_ASSET__CkyhhGbe__"